import React from "react";
import { Button, Card, CardBody } from "reactstrap";
import Breadcrumbs from "components/Breadcrumbs/breadcrumbs";
import TopHeader from "components/TopHeader/topHeader";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import useApi from "../../../apiHooks/apiHooks";
import Swal from "sweetalert2";
import displayToast from "functions/displayToast";

export default function CompaniesCreate() {
    const [cookies, setCookie] = useCookies();
    const { createCompany } = useApi();

    // Formik
    const history = useHistory();
    const initialValues = { name: "", email: "", password: "" };
    const validationSchema = Yup.object({
        name: Yup.string().required("Company Name is required"),
        email: Yup.string().required("Company Email is required"),
        password: Yup.string().required("Password is required"),
    });

    const onSubmit = (values) => {
        handleSubmit(values);
    };

    const handleSubmit = async (data) => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            await createCompany(data, headers);
            displayToast("success", "Company created successfully");
            history.push("/admin/companies");
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
            displayToast("error", "An Error has occurred");
        }
    };

    // Styles
    const styles = {
        input: { padding: "0.75rem", width: "70%" },
    };
    return (
        <div className="m-5">
            <TopHeader title="Create New Company" />
            <Breadcrumbs
                pageLink="/admin/companies"
                pageName="Companies"
                currentPageName="Create New"
            />
            <Card className="my-5">
                <CardBody>
                    <h3
                        className="mb-5 mt-3"
                        style={{ fontWeight: "700", marginLeft: "2em" }}
                    >
                        Fill the following fields to create a new company:
                    </h3>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {(formik) => (
                            <Form
                                style={{ marginTop: "2em", marginLeft: "2em" }}
                            >
                                <div className="form-group row my-5">
                                    <label
                                        className="col-sm-2 col-form-label"
                                        style={{ fontWeight: "700" }}
                                    >
                                        Company Name:
                                    </label>
                                    <div className="col-sm-10">
                                        <Field
                                            name="name"
                                            id="name"
                                            className="form-control"
                                            placeholder="Name Company"
                                            style={styles.input}
                                            value={formik.values.name}
                                        />
                                        <ErrorMessage
                                            component="div"
                                            className="red-text"
                                            name="name"
                                        />
                                    </div>
                                </div>

                                <div className="form-group row my-5">
                                    <label
                                        className="col-sm-2 col-form-label"
                                        style={{ fontWeight: "700" }}
                                    >
                                        Email:
                                    </label>
                                    <div className="col-sm-10">
                                        <Field
                                            name="email"
                                            type="email"
                                            id="email"
                                            className="form-control"
                                            placeholder="Name Email Company"
                                            value={formik.values.email}
                                            style={styles.input}
                                        />
                                        <ErrorMessage
                                            component="div"
                                            className="red-text"
                                            name="email"
                                        />
                                    </div>
                                </div>

                                <div className="form-group row my-5">
                                    <label
                                        className="col-sm-2 col-form-label"
                                        style={{ fontWeight: "700" }}
                                    >
                                        Password:
                                    </label>
                                    <div className="col-sm-10">
                                        <Field
                                            name="password"
                                            type="password"
                                            id="password"
                                            className="form-control"
                                            style={styles.input}
                                            value={formik.values.password}
                                        />
                                        <ErrorMessage
                                            component="div"
                                            className="red-text"
                                            name="password"
                                        />
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        marginTop: "4em",
                                    }}
                                >
                                    <Button
                                        className="btn-icon btn-3"
                                        style={{
                                            backgroundColor: "#01497C",
                                            color: "white",
                                            width: "12%",
                                        }}
                                        type="submit"
                                    >
                                        Create
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </div>
    );
}
